const topLevelComponentSelector = '#aftersell-pdp-upsell';
const cssToAdd = '.pdp-widget .upsell-header{color: #444f65;font-size: 18px;font-weight: 700;letter-spacing: 2px;}.pdp-widget .product-card-container.vertical {flex-direction: row;overflow-x: scroll;padding-left: 15px;}.pdp-widget .add-button-trigger{position: absolute;left: -15px;top: calc(50% - 15px);height: 30px;width: 30px;}.pdp-widget .product-card.vertical{position:relative;min-width: 70%;background: #ffffff;border-radius: 10px;}.pdp-widget .add-button{display:none;border: 1px solid var(--colorTextBody); background: var(--colorTextBody);text-transform: uppercase;}.pdp-widget .add-button:hover{background: transparent; color: var(--colorTextBody);border-color: var(--colorTextBody);}.pdp-widget .product-info{padding-bottom:0;}.pdp-widget .product-title{font-weight: 400; font-size:16px;}.pdp-widget .price-info{color: rgb(82, 196, 26);font-size: 16px;font-weight: 700;}.pdp-widget .product-image-wrapper.vertical .product-image{height: 80px;width:80px;}.pdp-widget .upsell-has-product{line-height: 1.2;padding: 10px 0; font-weight:400; text-align: left;}';

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => adjustShadowRootStyles(topLevelComponentSelector, cssToAdd), 40);
});
//adjustShadowRootStyles(topLevelComponentSelector, cssToAdd);

function adjustShadowRootStyles(hostsSelector, styles) {
  const shadowHost = document.querySelector(hostsSelector);
  if (!shadowHost || !shadowHost.shadowRoot) return;
  if (document.querySelector("#upsell-has-container")) return;
  const element = shadowHost.shadowRoot;
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(styles);
  updateProductTitles(element);
  queryShadowRootDeep(element);
  element.adoptedStyleSheets = [...element.adoptedStyleSheets, sheet];
}

// A helper function
function queryShadowRootDeep(element) {

 const buttonElements = element.querySelectorAll('.add-button');
 if(buttonElements.length > 0){
  addCheckClass();
 }
  buttonElements.forEach((selector) => {
    addCheckboxAndListener(selector);
  });
}

function addCheckboxAndListener(button) {
  const checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  checkbox.className = "add-button-trigger";
  const parent = button.parentNode;
  parent.insertBefore(checkbox, button);
  checkbox.addEventListener("change", function () {
    if (this.checked) {
      button.click();
    }
  });
}


function addCheckClass() {
  const container = document.createElement("div");
  const element = document.querySelector(topLevelComponentSelector);
  container.id = "upsell-has-container";
  element.parentNode.insertBefore(container, element);
}

function updateProductTitles(element) {
  const productLinks = element.querySelectorAll(".product-info a");
if(productLinks.length > 0){

  productLinks.forEach(link => {
    const container = document.createElement("h5");
    container.className = "upsell-has-product";
    if (link.getAttribute("href") === "/products/3-sock-scarf-gift-box-sku-sp028-3-box-small") {
      const title = link.querySelector(".product-title");
      if (title && !link.querySelector(".upsell-has-product")) {
        
         container.innerHTML = "Holds up to 3 pairs of socks";
        title.after(container);
      }
    }
    if (link.getAttribute("href") === "/products/6-sock-box") {
      const title = link.querySelector(".product-title");
      if (title &&  !link.querySelector(".upsell-has-product")) {
        container.innerHTML = "Holds up to 6 pairs of socks";
        title.after(container);
      }
    }
  });
}
}

const observer1 = new MutationObserver(() => {
  adjustShadowRootStyles(topLevelComponentSelector, cssToAdd);
});

observer1.observe(document.body, {
  childList: true,
  subtree: true
});

